export const permissionLevelOptions = ['ADMIN', 'HRBP'];
export const DEFAULT_USER_GROUPS = ['testLdapGroupName2', 'MTuserGroupName3', 'testUserGroupName1'];
